import type { BuildCalibrationOverlay } from "./types";

const CALIBRATION_RGB: [number, number, number] = [245, 158, 11];
const CALIBRATION_OVERLAY_ID = "calibration-pick";

/**
 * Renders the calibration anchor + target as a synthetic route in the
 * existing route-creation overlay slot. Reuses the SVG layer instead of
 * adding a dedicated calibration layer — no panel changes required.
 */
export const buildCalibrationOverlay: BuildCalibrationOverlay = ({
  calibration,
  hoverPosition,
}) => {
  const nodes = [];
  const edges = [];
  if (calibration.phase !== "picking-anchor") {
    nodes.push({ id: 0, x: calibration.anchor.x, y: calibration.anchor.y });
  }
  if (calibration.phase === "modal") {
    nodes.push({ id: 1, x: calibration.target.x, y: calibration.target.y });
    edges.push({ from: 0, to: 1 });
  }

  return {
    routes: [
      {
        id: CALIBRATION_OVERLAY_ID,
        nodes,
        edges,
        rgb: CALIBRATION_RGB,
        isActive: true,
      },
    ],
    hoverPosition:
      calibration.phase === "picking-target" ? hoverPosition : null,
    isEditable: false,
  };
};
